import { KestrelViewerMessageCallbackAPI } from 'features/kestrelViewer/types/KestrelViewerInterfaces'

import { KVMessageDef } from './index'

export function getControlMessage() {
  return {
    type: 'control',
    requiredData: ['control'],

    callback: (
      json: Record<string, unknown>,
      kv: KestrelViewerMessageCallbackAPI
    ) => {
      if (!kv.pixelStream) return

      if (json.control) {
        // TODO: Make this resolution scalar configurable by user
        kv.pixelStream.emitCommand({
          'Resolution.Width': kv.videoParent.current!.clientWidth * 2,
          'Resolution.Height': kv.videoParent.current!.clientHeight * 2,
        })
      } else {
        // Disable user interaction and notify user
      }
    },
  } as KVMessageDef
}
